import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBook, FiArrowRight, FiHeart, FiMapPin, FiClipboard } = FiIcons;

function WelcomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-emerald-50 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <div className="mb-12">
          <div className="inline-flex p-4 bg-white/80 backdrop-blur-sm rounded-2xl shadow-sm mb-6">
            <SafeIcon icon={FiBook} className="w-12 h-12 text-emerald-700" />
          </div>
          <h1 style={{
      color: 'rgb(37, 88, 171)',
      marginLeft: '80px',
      marginRight: '80px',
      textAlign: 'center'
    }} className="font-serif text-5xl text-gray-800 mb-4">Your GospelWise Author Journey Starts Here</h1>
          <p className="text-2xl text-emerald-700 font-medium mb-6">
            A Mini Planner for Christian Authors
          </p>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            You were created and gifted to create. 
            <span className="block mt-2 text-amber-700 font-medium">
              Let's make a plan together.
            </span>
          </p>
        </div>

        {/* Author Intro */}
        <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border border-amber-100 mb-12">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <SafeIcon icon={FiHeart} className="w-6 h-6 text-rose-600" />
            <h2 className="font-serif text-xl text-gray-800">
              From Jeremy Bouma
            </h2>
          </div>
          <p className="text-gray-700 leading-relaxed max-w-2xl mx-auto">
            I know what it's like to feel called to write but overwhelmed by where to start. 
            Whether you're writing fiction or nonfiction, this simple planner will help you 
            take the next faithful step in your author journey.
          </p>
        </div>

        {/* Main Actions */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {/* Quiz Option */}
          <Link 
            to="/quiz"
            className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl border border-amber-200 hover:shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            <div className="mb-4">
              <div className="inline-flex p-3 bg-amber-100 rounded-xl group-hover:bg-amber-200 transition-colors">
                <SafeIcon icon={FiMapPin} className="w-6 h-6 text-amber-700" />
              </div>
            </div>
            <h3 className="font-serif text-xl text-gray-800 mb-3">
              Find Your Focus
            </h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Take our quick quiz to discover which area of your author journey to focus on first.
            </p>
            <div className="flex items-center justify-center space-x-2 text-amber-700 font-medium">
              <span>Take Quiz</span>
              <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Roadmap Option */}
          <Link 
            to="/roadmap"
            className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl border border-emerald-200 hover:shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            <div className="mb-4">
              <div className="inline-flex p-3 bg-emerald-100 rounded-xl group-hover:bg-emerald-200 transition-colors">
                <SafeIcon icon={FiBook} className="w-6 h-6 text-emerald-700" />
              </div>
            </div>
            <h3 className="font-serif text-xl text-gray-800 mb-3">
              Explore the Roadmap
            </h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Browse all four stages of the Christian author journey at your own pace.
            </p>
            <div className="flex items-center justify-center space-x-2 text-emerald-700 font-medium">
              <span>View Roadmap</span>
              <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>

          {/* Direct to Planning */}
          <Link 
            to="/checklist"
            className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl border border-rose-200 hover:shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            <div className="mb-4">
              <div className="inline-flex p-3 bg-rose-100 rounded-xl group-hover:bg-rose-200 transition-colors">
                <SafeIcon icon={FiClipboard} className="w-6 h-6 text-rose-700" />
              </div>
            </div>
            <h3 className="font-serif text-xl text-gray-800 mb-3">
              Plan Your Book
            </h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Ready to start planning? Jump straight into our interactive book planning checklist.
            </p>
            <div className="flex items-center justify-center space-x-2 text-rose-700 font-medium">
              <span>Start Planning</span>
              <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        </div>

        {/* Encouraging Message */}
        <div className="text-center">
          <p className="text-gray-600 italic text-lg">
            "Let's walk this road together."
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;